@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div
  class="popup_main_div add_edit_settelmatter_main"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 mat-dialog-title cdkDragHandle class="mat-dialog-header">
    <span>Matter Address</span>
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
      <form
        name="matterAddressForm"
        id="matterAddressForm"
        [formGroup]="matterAddressForm"
        fxLayout="column"
        fxLayoutAlign="start"
        fxFlex="1 0 auto"
      >
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <!-- <mat-tab-group mat-align-tabs="start">
          <mat-tab label="Address">
            <app-settlment-address [errorWarningData]="errorWarningData" [matterAddressForm]="matterAddressForm"></app-settlment-address>
          </mat-tab>
          <mat-tab label="Title">
            <app-settlment-title [errorWarningData]="errorWarningData" [matterAddressForm]="matterAddressForm"></app-settlment-title>
          </mat-tab>
          <mat-tab label="Parent Title">
            <app-settlment-parent-title [errorWarningData]="errorWarningData" [matterAddressForm]="matterAddressForm"></app-settlment-parent-title>
          </mat-tab>
          <mat-tab label="Strata">
            <app-settlment-strata [errorWarningData]="errorWarningData" [matterAddressForm]="matterAddressForm"></app-settlment-strata>
          </mat-tab>
          <mat-tab label="Council">
            <app-settlment-council [errorWarningData]="errorWarningData" [matterAddressForm]="matterAddressForm"></app-settlment-council>
          </mat-tab>
          <mat-tab label="Crown Allotment">
            <app-settlment-crow-allotment [errorWarningData]="errorWarningData" [matterAddressForm]="matterAddressForm">
            </app-settlment-crow-allotment>
          </mat-tab>
        </mat-tab-group> -->

          <div fxFlex="100">
            <mat-accordion class="matter-accordion" multi="false">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Address</mat-panel-title>
                </mat-expansion-panel-header>
                <app-settlment-address
                  [errorWarningData]="errorWarningData"
                  [matterAddressForm]="matterAddressForm"
                ></app-settlment-address>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Title</mat-panel-title>
                </mat-expansion-panel-header>
                <app-settlment-title
                  [errorWarningData]="errorWarningData"
                  [matterAddressForm]="matterAddressForm"
                ></app-settlment-title>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Parent Title</mat-panel-title>
                </mat-expansion-panel-header>
                <app-settlment-parent-title
                  [errorWarningData]="errorWarningData"
                  [matterAddressForm]="matterAddressForm"
                ></app-settlment-parent-title>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Strata</mat-panel-title>
                </mat-expansion-panel-header>
                <app-settlment-strata
                  [errorWarningData]="errorWarningData"
                  [matterAddressForm]="matterAddressForm"
                ></app-settlment-strata>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Council</mat-panel-title>
                </mat-expansion-panel-header>
                <app-settlment-council
                  [errorWarningData]="errorWarningData"
                  [matterAddressForm]="matterAddressForm"
                ></app-settlment-council>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Crown Allotment</mat-panel-title>
                </mat-expansion-panel-header>
                <app-settlment-crow-allotment
                  [errorWarningData]="errorWarningData"
                  [matterAddressForm]="matterAddressForm"
                ></app-settlment-crow-allotment>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Connections</mat-panel-title>
                </mat-expansion-panel-header>
                <app-settlement-connection
                  [errorWarningData]="errorWarningData"
                  [matterAddressForm]="matterAddressForm"
                ></app-settlement-connection>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Insurance</mat-panel-title>
                </mat-expansion-panel-header>
                <app-settlement-insurance
                  [errorWarningData]="errorWarningData"
                  [matterAddressForm]="matterAddressForm"
                ></app-settlement-insurance>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </form>
    </div>
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    <button
      matButton="filled"
      class="mat-accent"
      (click)="SaveMatterAddress()"
      [disabled]="isspiner"
    >
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      Save
    </button>
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
  </mat-dialog-actions>
</div>
